package com.ijoin.platform

import kotlinx.browser.window

/**
 * JS implementation - detects mobile OS from browser user agent.
 */
actual fun getWebMobileOS(): MobileOS {
    val userAgent = window.navigator.userAgent.lowercase()

    return when {
        userAgent.contains("iphone") || userAgent.contains("ipad") || userAgent.contains("ipod") -> MobileOS.IOS
        userAgent.contains("android") -> MobileOS.ANDROID
        else -> MobileOS.NONE
    }
}

actual fun isWebMobile(): Boolean {
    val userAgent = window.navigator.userAgent.lowercase()

    // Check for common mobile indicators
    return userAgent.contains("mobile") ||
            userAgent.contains("android") ||
            userAgent.contains("iphone") ||
            userAgent.contains("ipad") ||
            userAgent.contains("ipod") ||
            // Also check for touch capability as a fallback
            window.navigator.asDynamic().maxTouchPoints > 0
}
